import { createAction, props } from '@ngrx/store';
import { IApplicationUser, IMenuByUserResponse } from './menu-by-user.model';

export const loadMenuByUser = createAction('[MenuByUser] Load', props<{ request: IApplicationUser }>());

export const loadMenuByUserSuccess = createAction(
  '[MenuByUser] Load Success',
  props<{ response: IMenuByUserResponse }>(),
);

export const loadMenuByUserFailure = createAction('[MenuByUser] Load Failure', props<{ error: string }>());

export const refreshMenuByUser = createAction('[MenuByUser] Refresh', props<{ request: IApplicationUser }>());

export const resetMenuByUser = createAction('[MenuByUser] Reset');
